import withAppTheme from '../../core/ThemeProvider/withAppTheme';
import { theme } from '../styles/index';

export default withAppTheme(theme);
